import styles from "./Stats.module.css";

const stats = [
  { num: "70", accent: "%", label: "Faster time to hire" },
  { num: "50", accent: "%", label: "Hiring cost savings" },
  { num: "AI", accent: "", label: "Focused SJTs for all Roles" },
  { num: "50", accent: "+", label: "Career Roles Available" },
];

export default function Stats() {
  return (
    <>
      <div className={styles.sectionHead}>
        <span className={styles.eyebrow}>Your possibilities & capabilities with us</span>
      </div>
      <section className={styles.section}>
        <div className={styles.container}>
          <div className={styles.grid}>
            {stats.map((s) => (
              <div key={s.label} className={styles.item}>
                <div className={styles.num}>
                  {s.num}
                  <span className={styles.accent}>{s.accent}</span>
                </div>
                <div className={styles.label}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
